import cx from 'classnames';
import styles from './NavigationCards.module.scss';
import { Container } from 'ui/components/4-habitats/Container';
import { Heading } from 'ui/components/1-atoms/Heading';
import {
	NavigationCardProps,
	NavigationCardsLinkType,
	NavigationCard,
} from 'ui/components/2-molecules/Card/NavigationCard';

export interface NavigationCardsProps {
	className?: string;
	heading?: string;
	cards: NavigationCardProps[];
	layout: '3' | '4' | '2-3';
	backgroundColor: 'white' | 'light' | 'dark';
	linkType?: NavigationCardsLinkType;
	spacingTop?: boolean;
}

export const NavigationCards: React.FC<NavigationCardsProps> = ({
	className,
	heading,
	cards,
	layout = '3',
	backgroundColor = 'white',
	linkType,
	spacingTop = true,
}) => {
	return (
		<div
			className={cx(
				styles.NavigationCards,
				className,
				{ [styles.NavigationCards___bg]: backgroundColor && backgroundColor !== 'white' },
				styles[`NavigationCards___bg-${backgroundColor}`],

				{
					[styles.NavigationCards___spacingTop]: spacingTop,
				},
			)}
		>
			<Container width="std">
				{heading && (
					<Heading className={styles.NavigationCards_heading} headingLevel="h2" style={'md'}>
						{heading}
					</Heading>
				)}
				{cards && (
					<ul
						className={cx(styles.NavigationCards_cards, styles[`NavigationCards_cards___layout-${layout}`])}
					>
						{cards.map((card, index) => (
							<li key={index} className={cx(styles.NavigationCards_item)}>
								<NavigationCard
									className={cx(styles.NavigationCards_card)}
									backgroundColor={backgroundColor !== 'white' ? 'white' : 'light'}
									centered={card.image?.url || card.icon?.url ? true : card.centered}
									linkType={linkType}
									{...card}
									adjustHeadingLevel={heading ? true : false}
								/>
							</li>
						))}
					</ul>
				)}
			</Container>
		</div>
	);
};
